{
    "FormEngineStaticDatasource": {
        "title": "Static Data",
        "description": "Manually insert static data to be used inside your form"
    },
    "mask": {
        "FormEngineStaticDatasource": {
            "description": "Description",
            "sourceType": "Source Type",
            "resultPath": "Result Path",
            "resultPathPlaceholder": "e.g. entries",
            "labelColumn": "Label Column",
            "labelColumnPlaceholder": "e.g. {{$i.Label}}",
            "valueColumn": "Value Column",
            "valueColumnPlaceholder": "e.g. {{$i.Value}}",
            "source": "Source",
            "setup": "Setup",
            "data": "Browse"
        }
    }
}